export const icons_hero_our_promise = require('./icons-hero-home.svg')
